import { render, staticRenderFns } from "./SliderV4.vue?vue&type=template&id=4cdf6ec8&"
import script from "./SliderV4.vue?vue&type=script&lang=js&"
export * from "./SliderV4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports